let data;
export default data = [
    {
        url1:"https://www.jefit.com/images/exercises/800_600/212.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/213.jpg",
        info:{
                Title:"Band Back Fly",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Bands"

            },
        button:"View History"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/16.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/17.jpg",
        info:{
                Title:"Barbell Close Grip Bench Press",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4660.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4661.jpg",
        info:{
                Title:"Barbell Close Grip Press Behind the Neck",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4696.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1841.jpg",
        info:{
                Title:"Barbell JM Press",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/612.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/613.jpg",
        info:{
                Title:"Barbell Lying Close Grip Triceps Press",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/976.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/977.jpg",
        info:{
                Title:"Barbell Overhead Tricep Extension",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/996.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/997.jpg",
        info:{
                Title:"Barbell Overhead Tricep Extension",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4652.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4653.jpg",
        info:{
                Title:"Barbell Rear Tricep Extension",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4748.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4749.jpg",
        info:{
                Title:"Barbell Reverse Grip Skullcrusher",
                group:"Main Muscle Group : Triceps",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
       
    },
    
    

]